// src/App.js
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute, { RootRoute } from "./components/ProtectedRoute";

// CONTEXT — NÃO ENTRA AQUI AGORA
// (AuthProvider deve ficar apenas no index.js)

// PÁGINAS
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Checkins from "./pages/Checkins";
import NewCheckin from "./pages/NewCheckin";
import Badges from "./pages/Badges";

import EditarPerfil from "./pages/EditarPerfil";
import PerfilPublico from "./pages/PerfilPublico";

// GRUPOS
import MeusGrupos from "./pages/grupos/MeusGrupos";
import CriarGrupo from "./pages/grupos/CriarGrupo";
import GrupoDetalhe from "./pages/grupos/GrupoDetalhe";
import ConvitesGrupos from "./pages/grupos/ConvitesGrupos";
import ConvidarMembros from "./pages/grupos/ConvidarMembros";

// NOVA PÁGINA — Buscar Grupo Público
import BuscarGrupoPublico from "./pages/grupos/BuscarGrupoPublico";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RootRoute />} />

        {/* LOGIN (PÚBLICO) */}
        <Route path="/login" element={<Login />} />

        {/* PERFIL PÚBLICO */}
        <Route path="/perfil/:alunoId" element={<PerfilPublico />} />

        {/* DASHBOARD */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* CHECK-INS */}
        <Route
          path="/checkins"
          element={
            <ProtectedRoute>
              <Checkins />
            </ProtectedRoute>
          }
        />
        <Route
          path="/checkins/new"
          element={
            <ProtectedRoute>
              <NewCheckin />
            </ProtectedRoute>
          }
        />

        {/* BADGES */}
        <Route
          path="/badges"
          element={
            <ProtectedRoute>
              <Badges />
            </ProtectedRoute>
          }
        />

        {/* EDITAR PERFIL */}
        <Route
          path="/me/editar"
          element={
            <ProtectedRoute>
              <EditarPerfil />
            </ProtectedRoute>
          }
        />

        {/* =============================
                MÓDULO DE GRUPOS
           ============================= */}

        {/* LISTA DE GRUPOS */}
        <Route
          path="/grupos"
          element={
            <ProtectedRoute>
              <MeusGrupos />
            </ProtectedRoute>
          }
        />

        {/* NOVO: BUSCAR GRUPOS PÚBLICOS */}
        <Route
          path="/grupos/buscar"
          element={
            <ProtectedRoute>
              <BuscarGrupoPublico />
            </ProtectedRoute>
          }
        />

        {/* CRIAR GRUPO */}
        <Route
          path="/grupos/novo"
          element={
            <ProtectedRoute>
              <CriarGrupo />
            </ProtectedRoute>
          }
        />

        {/* DETALHE */}
        <Route
          path="/grupos/:id"
          element={
            <ProtectedRoute>
              <GrupoDetalhe />
            </ProtectedRoute>
          }
        />

        {/* CONVIDAR */}
        <Route
          path="/grupos/:id/convidar"
          element={
            <ProtectedRoute>
              <ConvidarMembros />
            </ProtectedRoute>
          }
        />

        {/* CONVITES */}
        <Route
          path="/grupos/convites"
          element={
            <ProtectedRoute>
              <ConvitesGrupos />
            </ProtectedRoute>
          }
        />

        {/* CATCH-ALL */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
